import { render, staticRenderFns } from "./linkTm.vue?vue&type=template&id=9db39a8e&"
import script from "./linkTm.vue?vue&type=script&lang=js&"
export * from "./linkTm.vue?vue&type=script&lang=js&"
import style0 from "./linkTm.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports